<div class="container">
  <brd-user-message
    title="Oh no!"
    subTitle="Your session is expired"
    message="Please reload the page for continue"
    img="super_frame.png"
    imgDisplayMode="cover"
    btnText="Refresh"
    (action)="redirect()"
  >
  </brd-user-message>
</div>
